import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Team from '../Team'

export default class extends Resource {
  static name = 'event_templates'

  static get fields () {
    return {
      id: new UUID(),
      despatch_template: new STRING(),
      in_transit_template: new STRING(),
      onboard_template: new STRING(),
      error_template: new STRING(),
      delivered_template: new STRING(),
      despatch_template_subject: new STRING(),
      in_transit_template_subject: new STRING(),
      onboard_template_subject: new STRING(),
      error_template_subject: new STRING(),
      delivered_template_subject: new STRING(),
      sms_despatch_template: new STRING(),
      sms_in_transit_template: new STRING(),
      sms_onboard_template: new STRING(),
      sms_error_template: new STRING(),
      sms_delivered_template: new STRING(),
      team: new ITEM(Team)
    }
  }
}
